import { findChainInfo } from "../../utils/helper";
import { useWithDrawApprovalSettingStore } from "../../zustand/store";
import ApprovalRegulation from "./ApprovalRegulation";
import { IRegulationObject } from "src/zustand/types";

const ApproveRegulationEditOperation = () => {
  const useStore = useWithDrawApprovalSettingStore((state) => state);
  const {
    chain_id,
    chain_type,
    withdraw_approval_regulation: regulationObj,
  } = useStore.recordForEdit.rawData;
  const chainCode = findChainInfo(String(chain_type), chain_id)?.chain_code;

  const handleUpdateRecord = (value: IRegulationObject) => {
    useStore.setUpdateRecordForEdit({
      editFields: {
        field: "withdraw_approval_regulation",
        value: value,
      },
    });
  };

  return (
    <ApprovalRegulation
      regulationObj={regulationObj}
      setRegulationObj={handleUpdateRecord}
      chainName={chainCode}
      mode="edit"
    />
  );
};

export default ApproveRegulationEditOperation;
